import { useEffect, useRef } from 'react';

const items = [
  { label: 'Sabor de comida de verdade', natural: true, industrial: false },
  { label: 'Pão macio e úmido', natural: true, industrial: false },
  { label: 'Feito no dia do pedido', natural: true, industrial: false },
  { label: 'Ingredientes que você reconhece', natural: true, industrial: false },
  { label: 'Validade natural (15 dias)', natural: true, industrial: false },
  { label: 'Praticidade no dia a dia', natural: true, industrial: false },
];

const ComparisonSection = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.querySelectorAll('.reveal').forEach((el) => {
              el.classList.add('revealed');
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="comparativo"
      ref={sectionRef}
      className="relative py-20 md:py-28 bg-background-100"
    >
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="reveal inline-flex items-center gap-2 font-label text-xs md:text-sm text-accent-600 tracking-widest uppercase mb-4">
              <span className="w-6 h-px bg-accent-400" />
              Por que a Naturalle
              <span className="w-6 h-px bg-accent-400" />
            </span>
            <h2 className="reveal reveal-delay-1 font-display text-3xl md:text-5xl text-foreground-900 leading-tight">
              Naturalle <span className="text-accent-600">vs</span> Industrializado
            </h2>
          </div>

          <div className="reveal rounded-3xl overflow-hidden bg-background-50 border border-background-200/70 shadow-sm">
            {/* Header */}
            <div className="grid grid-cols-[1fr_100px_100px] md:grid-cols-[1fr_140px_140px] bg-gradient-to-r from-accent-500 to-accent-400 text-white">
              <div className="px-5 py-4 md:px-6 md:py-5 font-label text-xs md:text-sm font-medium tracking-wide">
                Características
              </div>
              <div className="px-3 py-4 md:px-6 md:py-5 text-center font-label text-xs md:text-sm font-semibold">
                <span className="hidden md:inline">Naturalle</span>
                <span className="md:hidden">Nat.</span>
              </div>
              <div className="px-3 py-4 md:px-6 md:py-5 text-center font-label text-xs md:text-sm">
                <span className="hidden md:inline">Industrializado</span>
                <span className="md:hidden">Ind.</span>
              </div>
            </div>

            {/* Rows */}
            {items.map((item, index) => (
              <div
                key={item.label}
                className={`reveal grid grid-cols-[1fr_100px_100px] md:grid-cols-[1fr_140px_140px] items-center transition-all ${
                  index % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                } hover:bg-secondary-50/40`}
                style={{ transitionDelay: `${index * 0.05}s` }}
              >
                <div className="px-5 py-3.5 md:px-6 md:py-4 font-body text-sm md:text-base text-foreground-700 border-b border-background-200/40">
                  {item.label}
                </div>
                <div className="px-3 py-3.5 md:px-6 md:py-4 text-center border-b border-background-200/40">
                  <i className="ri-check-line text-lg md:text-xl text-primary-500" />
                </div>
                <div className="px-3 py-3.5 md:px-6 md:py-4 text-center border-b border-background-200/40">
                  <i className="ri-close-line text-lg md:text-xl text-foreground-300" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;